// // src/components/GuidedTour/GuidedTour.jsx
// import React, { useEffect, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import "./GuidedTour.css";

// const GuidedTour = ({
//   steps = [],
//   stepIndex = 0,
//   setStepIndex,
//   onFinish,
//   allowNavigation = true,
// }) => {
//   const [targetElement, setTargetElement] = useState(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const step = steps[stepIndex] || null;
//   const isLast = stepIndex === steps.length - 1;
//   const isFirst = stepIndex === 0;

//   const allowInteraction = !!step?.allowInteraction;
//   const needsRealConfirmation = step?.waitForRealCheckbox === true;
//   const waitForCancelClick = step?.waitForCancelClick === true;
//   const waitForRealClick = step?.waitForRealClick === true;
//   const autoNextAfter = step?.autoNextAfter || null;

//   // Resume tour from URL query param
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const tourStepParam = params.get("tourStep");

//     if (tourStepParam !== null) {
//       const targetStep = Number(tourStepParam);
//       if (!isNaN(targetStep) && targetStep >= 0 && targetStep < steps.length) {
//         setStepIndex(targetStep);
//       }
//       // Clean URL automatically
//       navigate(location.pathname, { replace: true });
//     }
//   }, [location.search, navigate, setStepIndex, steps.length]);

//   // Find target element with retry
//   useEffect(() => {
//     if (!step?.selector) return;
//     let attempts = 0;
//     let cancelled = false;

//     const findElement = () => {
//       if (cancelled) return;
//       const el = document.querySelector(step.selector);
//       if (el) {
//         setTargetElement(el);
//       } else if (attempts < 120) {
//         attempts++;
//         setTimeout(findElement, 250);
//       }
//     };

//     setTargetElement(null);
//     findElement();

//     return () => { cancelled = true; };
//   }, [step]);

//   // Auto next after delay
//   useEffect(() => {
//     if (!autoNextAfter || !targetElement) return;

//     const timer = setTimeout(() => {
//       if (!isLast) {
//         setStepIndex(stepIndex + 1);
//       } else {
//         onFinish?.();
//       }
//     }, autoNextAfter);

//     return () => clearTimeout(timer);
//   }, [autoNextAfter, targetElement, stepIndex, isLast, setStepIndex, onFinish]);

//   // Checkbox auto advance
//   useEffect(() => {
//     if (!needsRealConfirmation || !targetElement) return;

//     const checkbox = targetElement.querySelector("input[type='checkbox']");
//     if (!checkbox) return;

//     const handleChange = (e) => {
//       if (e.target.checked && !isLast) {
//         setStepIndex(stepIndex + 1);
//       }
//     };

//     checkbox.addEventListener("change", handleChange);
//     return () => checkbox.removeEventListener("change", handleChange);
//   }, [needsRealConfirmation, targetElement, stepIndex, isLast, setStepIndex]);

//   // Cancel button advance
//   useEffect(() => {
//     if (!waitForCancelClick || !targetElement) return;

//     const handleClick = () => {
//       setTimeout(() => {
//         if (!isLast) {
//           setStepIndex(prev => prev + 1);
//         } else {
//           onFinish?.();
//         }
//       }, 60);
//     };

//     targetElement.addEventListener("click", handleClick);
//     return () => targetElement.removeEventListener("click", handleClick);
//   }, [waitForCancelClick, targetElement, isLast, setStepIndex, onFinish]);

//   // Real click advance
//   useEffect(() => {
//     if (!waitForRealClick || !targetElement) return;

//     const handleClick = () => {
//       setTimeout(() => {
//         if (!isLast) {
//           setStepIndex(prev => prev + 1);
//         } else {
//           onFinish?.();
//         }
//       }, 80);
//     };

//     targetElement.addEventListener("click", handleClick);
//     return () => targetElement.removeEventListener("click", handleClick);
//   }, [waitForRealClick, targetElement, isLast, setStepIndex, onFinish]);

//   // Scroll target into view
//   useEffect(() => {
//     if (targetElement) {
//       targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
//     }
//   }, [targetElement]);

//   // Disable body scroll
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, []);

//   if (!step || !targetElement) return null;

//   const rect = targetElement.getBoundingClientRect();
//   const TOOLTIP_HEIGHT_EST = 340;
//   const GAP = 24;
//   const MARGIN = 20;

//   const spaceBelow = window.innerHeight - rect.bottom;
//   const spaceAbove = rect.top;

//   let placeAbove = spaceBelow < TOOLTIP_HEIGHT_EST + GAP && spaceAbove > TOOLTIP_HEIGHT_EST + GAP;
//   if (rect.top < 100) placeAbove = false;

//   let tooltipTop = placeAbove
//     ? Math.max(MARGIN, rect.top - TOOLTIP_HEIGHT_EST - GAP)
//     : Math.min(rect.bottom + GAP, window.innerHeight - TOOLTIP_HEIGHT_EST - MARGIN);

//   const tooltipWidth = 320;
//   let tooltipLeft = Math.max(
//     MARGIN,
//     Math.min(
//       rect.left + rect.width / 2 - tooltipWidth / 2,
//       window.innerWidth - tooltipWidth - MARGIN
//     )
//   );

//   // Dynamic positioning overrides
//   const selector = step.selector || "";

//   const isPopupStep =
//     selector.includes(".tour-popup-") ||
//     selector.includes(".question-description") ||
//     selector.includes(".tour-camera-area") ||
//     selector.includes(".tour-audio-bar") ||
//     selector.includes(".tour-save-btn");

//   if (isPopupStep) {
//     tooltipTop = rect.top + rect.height / 2 - 100;
//     tooltipLeft = rect.left - tooltipWidth - 20;
//     if (tooltipLeft < 20) tooltipLeft = rect.right + 20;
//   }

//   const isHeaderStep =
//     selector.includes(".tour-exam-name") ||
//     selector.includes(".dummy-timer");

//   if (isHeaderStep) {
//     tooltipTop = rect.bottom + 20;
//     tooltipLeft = rect.left;
//     const centerLeft = rect.left + rect.width / 2 - tooltipWidth / 2;
//     if (centerLeft > 20 && centerLeft + tooltipWidth < window.innerWidth - 20) {
//       tooltipLeft = centerLeft;
//     }
//     if (tooltipTop + 220 > window.innerHeight) {
//       tooltipTop = rect.top - 260;
//     }
//   }

//   // Navigation & button handlers
//   const handleSkip = () => onFinish?.();

//   const handlePrev = () => {
//     if (isFirst) return;

//     const prevIndex = stepIndex - 1;
//     const prevStep = steps[prevIndex];

//     if (prevStep?.route && prevStep.route !== location.pathname) {
//       navigate(`${prevStep.route}?tourStep=${prevIndex}`);
//     } else {
//       setStepIndex(prevIndex);
//     }
//   };

//   const handleNext = () => {
//     if (isLast) {
//       onFinish?.();
//       navigate("/users/dashboard");
//       return;
//     }

//     const nextIndex = stepIndex + 1;
//     const nextStep = steps[nextIndex];

//     if (nextStep?.route && nextStep.route !== location.pathname) {
//       navigate(`${nextStep.route}?tourStep=${nextIndex}`);
//     } else {
//       setStepIndex(nextIndex);
//     }
//   };

//   return (
//     <>
//       {/* SPOTLIGHT + DARK OVERLAY FOR ALL STEPS */}
//       <div
//         className="gt-spotlight"
//         style={{
//           position: "fixed",
//           top: rect.top - 50,
//           left: rect.left - 50,
//           width: rect.width + 100,
//           height: rect.height + 100,
//           borderRadius: "16px",
//           boxShadow: "0 0 0 9999px rgba(0,0,0,0.75)",
//           pointerEvents: allowInteraction ? "none" : "auto",
//           zIndex: 9997,
//         }}
//       />

//       {/* HIGHLIGHT BORDER FOR ALL STEPS */}
//       <div
//         className="gt-highlight"
//         style={{
//           top: rect.top - 10,
//           left: rect.left - 10,
//           width: rect.width + 20,
//           height: rect.height + 20,
//           pointerEvents: "none",
//           border: "3px solid #6366f1", // indigo/blue border for visibility
//           borderRadius: "8px",
//           zIndex: 9998,
//         }}
//       />

//       {/* TOOLTIP */}
//       <div
//         className={`gt-tooltip ${placeAbove ? "gt-tooltip-above" : "gt-tooltip-below"}`}
//         style={{
//           position: "fixed",
//           top: tooltipTop,
//           left: tooltipLeft,
//           maxWidth: tooltipWidth,
//           zIndex: 9999,
//         }}
//       >
//         <div className="gt-header">
//           <div className="gt-avatar">👤</div>
//           <div>
//             <div className="gt-guide-name">Guide from Audree</div>
//             <div className="gt-guide-subtitle">Quick tour</div>
//           </div>
//           <button className="gt-close" onClick={handleSkip}>×</button>
//         </div>

//         <div className="gt-content">
//           {step.title && <h3 className="gt-title">{step.title}</h3>}
//           {step.text && <p className="gt-text">{step.text}</p>}

//           {needsRealConfirmation && (
//             <div className="gt-hint">Please check the box to continue →</div>
//           )}
//           {waitForCancelClick && (
//             <div className="gt-hint">Click the Cancel button to continue →</div>
//           )}
//           {waitForRealClick && (
//             <div className="gt-hint">Click the highlighted element to continue →</div>
//           )}
//           {autoNextAfter && (
//             <div className="gt-hint">Continuing automatically...</div>
//           )}
//         </div>

//         <div className="gt-footer">
//           <span className="gt-progress">
//             {stepIndex + 1} of {steps.length}
//           </span>

//           <div className="gt-buttons">
//             <button
//               className="gt-prev-btn"
//               onClick={handlePrev}
//               disabled={isFirst}
//             >
//               ← Previous
//             </button>

//             {!allowInteraction && !isLast && (
//               <button className="gt-next-btn" onClick={handleNext}>
//                 Next →
//               </button>
//             )}

//             {isLast && (
//               <button
//                 className="gt-finish-btn"
//                 onClick={() => {
//                   onFinish?.();
//                   navigate("/users/dashboard");
//                 }}
//               >
//                 End Tour
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default GuidedTour;



// src/components/GuidedTour/GuidedTour.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./GuidedTour.css";

const GuidedTour = ({
  steps = [],
  stepIndex = 0,
  setStepIndex,
  onFinish,
  allowNavigation = true,
}) => {
  const [targetElement, setTargetElement] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const step = steps[stepIndex] || null;
  const isLast = stepIndex === steps.length - 1;
  const isFirst = stepIndex === 0;

  const allowInteraction = !!step?.allowInteraction;
  const needsRealConfirmation = step?.waitForRealCheckbox === true;
  const waitForCancelClick = step?.waitForCancelClick === true;
  const waitForRealClick = step?.waitForRealClick === true;
  const autoNextAfter = step?.autoNextAfter || null;

  // Resume tour from URL query param
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tourStepParam = params.get("tourStep");

    if (tourStepParam !== null) {
      const targetStep = Number(tourStepParam);
      if (!isNaN(targetStep) && targetStep >= 0 && targetStep < steps.length) {
        setStepIndex(targetStep);
      }
      // Clean URL automatically
      navigate(location.pathname, { replace: true });
    }
  }, [location.search, navigate, setStepIndex, steps.length]);

  // Find target element with retry
  useEffect(() => {
    if (!step?.selector) return;
    let attempts = 0;
    let cancelled = false;

    const findElement = () => {
      if (cancelled) return;
      const el = document.querySelector(step.selector);
      if (el) {
        setTargetElement(el);
      } else if (attempts < 120) {
        attempts++;
        setTimeout(findElement, 250);
      }
    };

    setTargetElement(null);
    findElement();

    return () => { cancelled = true; };
  }, [step]);

  // Auto next after delay
  useEffect(() => {
    if (!autoNextAfter || !targetElement) return;

    const timer = setTimeout(() => {
      if (!isLast) {
        setStepIndex(stepIndex + 1);
      } else {
        onFinish?.();
      }
    }, autoNextAfter);

    return () => clearTimeout(timer);
  }, [autoNextAfter, targetElement, stepIndex, isLast, setStepIndex, onFinish]);

  // Checkbox auto advance
  useEffect(() => {
    if (!needsRealConfirmation || !targetElement) return;

    const checkbox = targetElement.querySelector("input[type='checkbox']");
    if (!checkbox) return;

    const handleChange = (e) => {
      if (e.target.checked && !isLast) {
        setStepIndex(stepIndex + 1);
      }
    };

    checkbox.addEventListener("change", handleChange);
    return () => checkbox.removeEventListener("change", handleChange);
  }, [needsRealConfirmation, targetElement, stepIndex, isLast, setStepIndex]);

  // Cancel button advance
  useEffect(() => {
    if (!waitForCancelClick || !targetElement) return;

    const handleClick = () => {
      setTimeout(() => {
        if (!isLast) {
          setStepIndex(prev => prev + 1);
        } else {
          onFinish?.();
        }
      }, 60);
    };

    targetElement.addEventListener("click", handleClick);
    return () => targetElement.removeEventListener("click", handleClick);
  }, [waitForCancelClick, targetElement, isLast, setStepIndex, onFinish]);

  // Real click advance
  useEffect(() => {
    if (!waitForRealClick || !targetElement) return;

    const handleClick = () => {
      setTimeout(() => {
        if (!isLast) {
          setStepIndex(prev => prev + 1);
        } else {
          onFinish?.();
        }
      }, 80);
    };

    targetElement.addEventListener("click", handleClick);
    return () => targetElement.removeEventListener("click", handleClick);
  }, [waitForRealClick, targetElement, isLast, setStepIndex, onFinish]);

  // Scroll target into view
  useEffect(() => {
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [targetElement]);

  // Disable body scroll
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  if (!step || !targetElement) return null;

  const rect = targetElement.getBoundingClientRect();
  const TOOLTIP_HEIGHT_EST = 340;
  const GAP = 24;
  const MARGIN = 20;

  const spaceBelow = window.innerHeight - rect.bottom;
  const spaceAbove = rect.top;

  let placeAbove = spaceBelow < TOOLTIP_HEIGHT_EST + GAP && spaceAbove > TOOLTIP_HEIGHT_EST + GAP;
  if (rect.top < 100) placeAbove = false;

  let tooltipTop = placeAbove
    ? Math.max(MARGIN, rect.top - TOOLTIP_HEIGHT_EST - GAP)
    : Math.min(rect.bottom + GAP, window.innerHeight - TOOLTIP_HEIGHT_EST - MARGIN);

  const tooltipWidth = 320;
  let tooltipLeft = Math.max(
    MARGIN,
    Math.min(
      rect.left + rect.width / 2 - tooltipWidth / 2,
      window.innerWidth - tooltipWidth - MARGIN
    )
  );

  // Dynamic positioning overrides
  const selector = step.selector || "";

  const isPopupStep =
    selector.includes(".tour-popup-") ||
    selector.includes(".question-description") ||
    selector.includes(".tour-camera-area") ||
    selector.includes(".tour-audio-bar") ||
    selector.includes(".tour-save-btn");

  if (isPopupStep) {
    tooltipTop = rect.top + rect.height / 2 - 100;
    tooltipLeft = rect.left - tooltipWidth - 20;
    if (tooltipLeft < 20) tooltipLeft = rect.right + 20;
  }

  const isHeaderStep =
    selector.includes(".tour-exam-name") ||
    selector.includes(".dummy-timer");

  if (isHeaderStep) {
    tooltipTop = rect.bottom + 20;
    tooltipLeft = rect.left;
    const centerLeft = rect.left + rect.width / 2 - tooltipWidth / 2;
    if (centerLeft > 20 && centerLeft + tooltipWidth < window.innerWidth - 20) {
      tooltipLeft = centerLeft;
    }
    if (tooltipTop + 220 > window.innerHeight) {
      tooltipTop = rect.top - 260;
    }
  }

  // Hide Previous button for specific final/critical steps
  const hidePrevious = [
    ".tour-popup-topline",
    ".vivasubmit-btn",
    ".finalsubmit",
    ".tour-close-btn",
  ].some(sel => selector.includes(sel));

  // Navigation & button handlers
  const handleSkip = () => onFinish?.();

  const handlePrev = () => {
    if (isFirst) return;

    const prevIndex = stepIndex - 1;
    const prevStep = steps[prevIndex];

    if (prevStep?.route && prevStep.route !== location.pathname) {
      navigate(`${prevStep.route}?tourStep=${prevIndex}`);
    } else {
      setStepIndex(prevIndex);
    }
  };

  const handleNext = () => {
    if (isLast) {
      onFinish?.();
      navigate("/users/dashboard");
      return;
    }

    const nextIndex = stepIndex + 1;
    const nextStep = steps[nextIndex];

    if (nextStep?.route && nextStep.route !== location.pathname) {
      navigate(`${nextStep.route}?tourStep=${nextIndex}`);
    } else {
      setStepIndex(nextIndex);
    }
  };

  return (
    <>
      {/* SPOTLIGHT + DARK OVERLAY FOR ALL STEPS */}
      <div
        className="gt-spotlight"
        style={{
          position: "fixed",
          top: rect.top - 50,
          left: rect.left - 50,
          width: rect.width + 100,
          height: rect.height + 100,
          borderRadius: "16px",
          boxShadow: "0 0 0 9999px rgba(0,0,0,0.75)",
          pointerEvents: allowInteraction ? "none" : "auto",
          zIndex: 9997,
        }}
      />

      {/* HIGHLIGHT BORDER FOR ALL STEPS */}
      <div
        className="gt-highlight"
        style={{
          top: rect.top - 10,
          left: rect.left - 10,
          width: rect.width + 20,
          height: rect.height + 20,
          pointerEvents: "none",
          border: "3px solid #6366f1",
          borderRadius: "8px",
          zIndex: 9998,
        }}
      />

      {/* TOOLTIP */}
      <div
        className={`gt-tooltip ${placeAbove ? "gt-tooltip-above" : "gt-tooltip-below"}`}
        style={{
          position: "fixed",
          top: tooltipTop,
          left: tooltipLeft,
          maxWidth: tooltipWidth,
          zIndex: 9999,
        }}
      >
        <div className="gt-header">
          <div className="gt-avatar">👤</div>
          <div>
            <div className="gt-guide-name">Guide from Audree</div>
            <div className="gt-guide-subtitle">Quick tour</div>
          </div>
          <button className="gt-close" onClick={handleSkip}>×</button>
        </div>

        <div className="gt-content">
          {step.title && <h3 className="gt-title">{step.title}</h3>}
          {step.text && <p className="gt-text">{step.text}</p>}

          {needsRealConfirmation && (
            <div className="gt-hint">Please check the box to continue →</div>
          )}
          {waitForCancelClick && (
            <div className="gt-hint">Click the Cancel button to continue →</div>
          )}
          {waitForRealClick && (
            <div className="gt-hint">Click the highlighted element to continue →</div>
          )}
          {autoNextAfter && (
            <div className="gt-hint">Continuing automatically...</div>
          )}
        </div>

        <div className="gt-footer">
          <span className="gt-progress">
            {stepIndex + 1} of {steps.length}
          </span>

          <div className="gt-buttons">
            {/* Hide Previous button for the four specific steps */}
            {!hidePrevious && (
              <button
                className="gt-prev-btn"
                onClick={handlePrev}
                disabled={isFirst}
              >
                ← Previous
              </button>
            )}

            {!allowInteraction && !isLast && (
              <button className="gt-next-btn" onClick={handleNext}>
                Next →
              </button>
            )}

            {isLast && (
              <button
                className="gt-finish-btn"
                onClick={() => {
                  onFinish?.();
                  navigate("/users/dashboard");
                }}
              >
                End Tour
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default GuidedTour;

